import React, { useState } from 'react';
import { motion } from 'framer-motion';

// Import images for the gallery slides. Adjust the paths according to your project structure.
import img4 from '../images/1.png';
// import img2 from '../images/2.jpg';
import img1 from '../images/3.jpg';
import img3 from '../images/4.jpg';

/**
 * Gallery component showcases a collection of sample products with a simple slider.
 *
 * Improvements over the original implementation:
 *  - Eliminates excess padding around each slide to remove visual gaps.
 *  - Uses object-cover on images so they fill the slide area without leaving gaps.
 *  - Adds subtle scale animations to the navigation arrows for better interactivity.
 *  - Smoothly transitions the slider using Framer Motion.
 */
const GalleryUpdated = () => {
  // Define an array of gallery items. Each entry can hold more metadata if needed.
  const galleryItems = [
    { id: 1, image: img1 },
    // { id: 2, image: img2 },
    { id: 3, image: img3 },
    { id: 4, image: img4 },
  ];

  // Track the current slide index. Modulo arithmetic handles wrap-around.
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = galleryItems.length;

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total);
  };

  return (
    <section id="sample-room" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          {/* Label */}
        <motion.span
  className="inline-flex items-center gap-2 px-5 py-2 mb-4 
             text-sm md:text-base font-playfair font-semibold 
             bg-gray-900 text-gray-100 rounded-full"
  initial={{ opacity: 0, y: 10 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.6, delay: 0.1 }}
>
  <span className="h-2 w-2 rounded-full bg-amber-400" />
  <span>Sample Room &amp; Product Showcase</span>
</motion.span>


          {/* Description */}
          <motion.p
            className="mb-8 text-lg leading-relaxed text-gray-700"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.25 }}
          >
            A selection of our T-shirts, sportswear and winter wear samples,
            highlighting our fabric quality, stitching standards and finishing
            details.
          </motion.p>

          {/* Slider section */}
          <div className="relative max-w-4xl mx-auto mb-6">
            {/* Navigation arrows for larger screens */}
            <motion.button
              onClick={prevSlide}
              aria-label="Previous sample"
              className="hidden sm:flex absolute left-3 top-1/2 -translate-y-1/2 z-20 h-10 w-10 items-center justify-center rounded-full bg-white shadow-md border border-gray-200 hover:bg-gray-100"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              ‹
            </motion.button>
            <motion.button
              onClick={nextSlide}
              aria-label="Next sample"
              className="hidden sm:flex absolute right-3 top-1/2 -translate-y-1/2 z-20 h-10 w-10 items-center justify-center rounded-full bg-white shadow-md border border-gray-200 hover:bg-gray-100"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              ›
            </motion.button>

            {/* Mobile arrows */}
            <div className="sm:hidden flex justify-between items-center mb-3">
              <motion.button
                onClick={prevSlide}
                className="px-3 py-1 text-xs border border-gray-300 bg-white rounded-full hover:bg-gray-100"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                ‹ Prev
              </motion.button>
              <motion.button
                onClick={nextSlide}
                className="px-3 py-1 text-xs border border-gray-300 bg-white rounded-full hover:bg-gray-100"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Next ›
              </motion.button>
            </div>

            {/* Viewport for slides */}
            <div className="overflow-hidden rounded-xl shadow-lg bg-white">
              <motion.div
                className="flex"
                animate={{ x: `-${(currentIndex * 100) / total}%` }}
                transition={{ duration: 0.6, ease: 'easeInOut' }}
                style={{ width: `${total * 100}%` }}
              >
                {galleryItems.map((item) => (
                  <div
                    key={item.id}
                    className="w-full flex-shrink-0 flex items-center justify-center"
                    style={{ width: `${100 / total}%` }}
                  >
                    <motion.div
                      className="w-full h-full flex items-center justify-center"
                      whileHover={{ scale: 1.02 }}
                      transition={{ duration: 0.3 }}
                    >
                      <img
                        src={item.image}
                        alt={`Sample ${item.id}`}
                        className="max-h-[420px] w-full object-cover"
                      />
                    </motion.div>
                  </div>
                ))}
              </motion.div>
            </div>
          </div>

          {/* Call-to-action button */}
     
        </motion.div>
      </div>
    </section>
  );
};

export default GalleryUpdated;